import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "reactstrap";
import CalendarioAltaAusencia from "./CalendarioAltaAusencia";

const tipoAusenciaMap = {
  VACACIONES: { abbr: "V", color: "success" },
  BAJA: { abbr: "B", color: "warning" },
  AUSENCIA: { abbr: "A", color: "info" },
  FESTIVO: { abbr: "F", color: "danger" },
};

const CalendarioPersonal = (props) => {
  const dias = useMemo(() => {
    const diasGenerados = [];

    for (let i = 1; i <= props.diasDelMes.length; i++) {
      const isFestivo = props.festivos.find((f) => f.dia === i);

      let color = "secondary";
      let abbr = "-";
      let tipo = "";
      let descripcion_id = "";
      let descripcion = "";
      let ausenciaId = "";

      if (isFestivo) {
        color = tipoAusenciaMap.FESTIVO.color;
        abbr = tipoAusenciaMap.FESTIVO.abbr;
      }

      const isAusencia = props.ausencias.find((a) => a.dia === i);
      if (isAusencia) {
        color = tipoAusenciaMap[isAusencia.tipo].color;
        abbr = tipoAusenciaMap[isAusencia.tipo].abbr;
        descripcion_id = isAusencia.descripcion_id?.toString();
        descripcion = isAusencia.descripcion;
        tipo = isAusencia.tipo;
        ausenciaId = isAusencia.id;
      }

      const incidenciasDelDia = props.permisosAusencia.filter(
        (permiso) => Number(permiso?.dia.split("-")[2]) === i
      );

      diasGenerados.push({
        dia: i,
        color,
        abbr,
        tipo,
        ausenciaId,
        descripcion_id,
        descripcion,
        incidencias: incidenciasDelDia,
      });
    }

    return diasGenerados;
  }, [props.diasDelMes.length, props.festivos, props.ausencias, props.permisosAusencia]);

  const [modalOpen, setModalOpen] = useState(false);
  const [diaSelected, setDiaSelected] = useState(null);

  const toggleModal = (d) => {
    if (d) {
      setDiaSelected(d);
      setModalOpen(true);
      return;
    }
    setModalOpen(false);
    setDiaSelected(null);
    if (props.refresh) {
      props.refresh();
    }
  };

  useEffect(() => {
    if (!modalOpen || !diaSelected) return;

    const updatedDay = dias.find((day) => day.dia === diaSelected.dia);
    if (!updatedDay) return;

    const currentIncidencias = (diaSelected.incidencias || []).map((inc) => inc.id).sort().join(",");
    const updatedIncidencias = (updatedDay.incidencias || []).map((inc) => inc.id).sort().join(",");

    const isSameDayState =
      diaSelected.ausenciaId === updatedDay.ausenciaId &&
      diaSelected.tipo === updatedDay.tipo &&
      diaSelected.descripcion_id === updatedDay.descripcion_id &&
      currentIncidencias === updatedIncidencias;

    if (!isSameDayState) {
      setDiaSelected(updatedDay);
    }
  }, [modalOpen, diaSelected, dias]);

  return (
    <>
      {dias.map((d) => {
        const tieneIncidencias = d.incidencias.length > 0;
        const cellColor = d.color === "secondary" && tieneIncidencias ? "primary" : d.color;

        return (
          <td key={`${props.empleadoId}-${d.dia}`} className="p-0 text-center">
            <Button
              className="btn position-relative"
              size="sm"
              color={cellColor}
              type="button"
              onClick={() => toggleModal(d)}
            >
              {d.abbr}
              {tieneIncidencias ? (
                <span
                  className="position-absolute bg-white text-primary rounded-circle border"
                  style={{
                    top: "-5px",
                    right: "-5px",
                    width: "14px",
                    height: "14px",
                    fontSize: "9px",
                    lineHeight: "13px",
                    fontWeight: "bold",
                  }}
                >
                  <i className="ni ni-watch-time" />
                </span>
              ) : null}
            </Button>
          </td>
        );
      })}

      <Modal className="modal-dialog-centered" isOpen={modalOpen} toggle={() => toggleModal()}>
        <div className="modal-header">
          <h5 className="modal-title">
            Dia {diaSelected?.dia} de {props.mes} del {props.anno}
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>x</span>
          </button>
        </div>
        <div className="modal-body">
          {diaSelected ? (
            <CalendarioAltaAusencia
              tipo={diaSelected.tipo}
              dia={diaSelected.dia}
              mes={props.mes}
              anno={props.anno}
              descripcion_id={diaSelected.descripcion_id}
              descripcion={diaSelected.descripcion}
              idAusencia={diaSelected.ausenciaId}
              incidencias={diaSelected.incidencias}
              empleadoId={props.empleadoId}
              onSaved={props.refresh}
            />
          ) : null}
        </div>
      </Modal>
    </>
  );
};

export default CalendarioPersonal;
